import * as React from 'react';
import './Notes.scss';
import Button from 'src/components/controls/forms/redesign/FormButton';
import FormRow from 'src/components/controls/forms/FormRow';
import Ownership from 'src/models/tract_detail/Ownership';
import { Field, AnyObject } from 'react-final-form';
import Form from 'src/components/controls/forms/Form';
import Owner from 'src/models/tract_detail/Owner';
import WIOwnership from 'src/models/tract_detail/WIOwnership';
import Dialog from 'src/components/common/Dialog.redesign';

export interface IOwnershipNotesStateProps {
    ownership: Ownership | WIOwnership | undefined;
    owners: Array<Owner> | undefined;
    errorMessage: string;
    context: number;
    selectedWIOwnershipId?: number;
    updateOwnershipNote: (note: Ownership) => void;
    onCloseDialog?: () => void;
}

type IOwnershipNotesPageProps = IOwnershipNotesStateProps;

class OwnershipNotesDialog extends React.Component<IOwnershipNotesPageProps> {
    constructor(props: IOwnershipNotesPageProps) {
        super(props);
    }

    submitNote = (values: AnyObject) => {
        console.log(values);
        const ownership = new Ownership();
        ownership.id = this.props.ownership.id;
        ownership.note = values.ownershipNote;
        this.props.updateOwnershipNote(ownership);
        this.props.onCloseDialog();
    };

    public render() {
        return (
            <Dialog title={`Ownership Notes`}>
                <div style={{ color: 'red', height: '3rem' }}>{this.props.errorMessage}</div>

                <Form
                    onSubmit={this.submitNote}
                    keepDirty={true}
                    initialValues={{
                        ownerNote: this.props?.owners?.find((x: Owner) => x.ownerLookUpId === this.props.ownership?.ownerLookUpId)?.note,
                        ownershipNote: this.props.ownership?.note,
                    }}
                >
                    <div style={{ width: '100rem' }}>
                        <div>Global Owner Note</div>
                        <div style={{ maxHeight: '20rem', overflow: 'auto' }}>
                            <Field name="ownerNote" disabled={true} component="textarea" cols={120} rows={10} />
                        </div>
                        {/* <div>Tract Ownership Note</div> */}
                        <div>
                            {this.props.context === 1 ?
                                'Mineral Ownership Note - Tract' :
                                this.props.context === 2 ?
                                    'Working Interest Note - Leasehold' :
                                    this.props.context === 3 ?
                                        'Surface Ownership Note - Tract' :
                                        'Context Missing'
                            }
                        </div>
                        <div style={{ maxHeight: '20rem', overflow: 'auto' }}>
                            <Field name="ownershipNote" component="textarea" cols={120} rows={10} />
                        </div>
                        <FormRow>
                            <Button type="submit" text="SAVE" intent="primary" />
                        </FormRow>
                    </div>
                </Form>
            </Dialog>
        );
    }
}

export default OwnershipNotesDialog;



// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/OwnershipNotesDialog.tsx